import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DisplayableItemListComponent } from '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component';
import { PrintCardTemplatesViewModel } from '../print-card-templates-view-model';

@Component({
  selector: 'app-print-card-template-list',
  templateUrl:
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.html',
  styleUrls: [
    '../../../../../../shared/components/displayable-content/displayable-item-list/displayable-item-list.component.scss',
    './print-card-template-list.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PrintCardTemplateListComponent extends DisplayableItemListComponent {
  constructor(
    printCardTemplatesViewModel: PrintCardTemplatesViewModel // Provided by parent component
  ) {
    super(printCardTemplatesViewModel);
  }
}
